document.addEventListener("DOMContentLoaded", function () {
  const rows = document.querySelectorAll(".body-charter .slideshow_row");

  if (rows.length === 0) {
    return;
  }

  rows.forEach((row) => {
    if (row.dataset.charterSlideInit === "true") {
      return;
    }

    const originalItems = Array.from(row.children).filter((item) =>
      item.classList.contains("slideshow_item"),
    );

    if (originalItems.length === 0) {
      return;
    }

    row.dataset.charterSlideInit = "true";

    originalItems.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.classList.add("is-clone");
      row.appendChild(clone);
    });

    const updateDistance = () => {
      const firstItem = originalItems[0];
      const firstClone = row.querySelector(".slideshow_item.is-clone");

      if (!firstItem || !firstClone) {
        return;
      }

      const distance = firstClone.offsetLeft - firstItem.offsetLeft;
      row.style.setProperty("--slide-distance", `${distance}px`);
      row.classList.add("is-ready");
    };

    updateDistance();

    if (document.fonts && typeof document.fonts.ready !== "undefined") {
      document.fonts.ready.then(updateDistance);
    }

    window.addEventListener("load", updateDistance, { once: true });
    window.addEventListener("resize", updateDistance);
  });
});
